export const LANG = {
  EN: "en",
  KO: "ko",
  ZH: "zh",
  JA: "ja",
};

export const LOCALE_LIST = [LANG.KO, LANG.EN, LANG.ZH, LANG.JA];
